@if (visible()) {
  <article class="fixed inset-0 z-100 flex items-center justify-center bg-black/60 backdrop-blur-sm">
    <div class="size-16 animate-spin rounded-full border-4 border-white border-t-transparent"></div>
  </article>
}
